import { render, staticRenderFns } from "./pull-refresh-slot.vue?vue&type=template&id=70b2bfc9&scoped=true&"
import script from "./pull-refresh-slot.vue?vue&type=script&lang=js&"
export * from "./pull-refresh-slot.vue?vue&type=script&lang=js&"
import style0 from "./pull-refresh-slot.vue?vue&type=style&index=0&id=70b2bfc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b2bfc9",
  null
  
)

export default component.exports